export const ENABLE_CONTENT_SORT_BY_CATEGORY_FLAG = 'enable_content_sort_by_category';
